import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import ProjectsComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import { buildFilterString } from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";

function ViewAllProjects() {
    const location = useLocation();
  const params = new URLSearchParams(location.search);
  const cityID = params.get("cityID");
  const city = params.get("city");
  const flag = location?.state?.flag;

  const [data, setdata] = useState([]);

  const [Loading, setLoading] = useState(true);

    useEffect(() => {
    getSearchResults();
  }, []);

  const getSearchResults = () => {
    setLoading(true);


   let filters = "";

   if( flag == 1){
    filters = `{CityID: { $in: [${cityID}] }}`
   }else if(flag == 2){
filters = `{}`
   }else{
    filters = `{SocietyID: { $in: [${cityID}] }}`
   }

    getRecords(398, 1000, filters, 1, "", (res) => {
    //  console.log("Search Results:", res);

      if (res.hasErrors === false) {
        if (res?.response?.records.length > 0) {
      
            setdata(res?.response?.records || []);
          

          setLoading(false);
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };



  return (
    <>
      <Header />

      <div className="content-wrapper">
        {/* Breadcrumb Start */}
        <div className="breadcrumb-wrap bg-f br-1">
          <div className="container">
            <div className="breadcrumb-title">
              <h2> {flag == 1 ? `Projects in ${city}` : flag == 2 ? "All Projects" : `Projects in ${city}`}</h2>
            </div>
          </div>
        </div>
        {/* Breadcrumb End */}

        {/* Listing section start */}
        <section className="listing-wrap ptb-100">
          <div className="container">
            <div className="row gx-5">
              <div className="col-xl-12">
                <div className="row align-items-center mb-25">
                  <div className="col-md-8">
                    <div className="profuct-result">
                      <p>{data?.length || 0} Results Found</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="filter-item-cat">
                      <select>
                        <option value={1}>Sort By Most Popular</option>
                        <option value={2}>Sort By High To Low</option>
                        <option value={3}>Sort By Low To High</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">

                   {data?.map((item, index) => (
                    <ProjectsComp key={index} {...item} />
                  ))}
                  {/* <div className="col-lg-64 col-md-4">
                    <div className="property-card style2">
                      <div className="property-img-slider">
                        <img
                          src="assets/img/property/property-10.jpg"
                          alt="Image"
                        />
                      </div>
                      <div className="property-info">
                        <div className="property-status-wrap">
                          <span className="property-status">For Rent</span>
                          <p className="property-price">
                            $34,900/<span>month</span>
                          </p>
                        </div>
                        <h3>
                          <a href="listing-details.html">Villa In Luis Park</a>
                        </h3>
                        <p>
                          <i className="flaticon-location" />
                          64, 1st Aveneu, High Steet, USA
                        </p>
                        <ul className="property-metainfo list-style">
                          <li>
                            <i className="flaticon-double-bed" />
                            06
                          </li>
                          <li>
                            <i className="flaticon-bath-tub" />
                            04
                          </li>
                          <li>
                            <i className="flaticon-square" />
                            3100 sqft
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                 
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Listing section end */}
          {Loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <TailSpin color="#00BFFF" height={80} width={80} />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default ViewAllProjects;
